import { render, staticRenderFns } from "./admin-address.vue?vue&type=template&id=0035526d"
import script from "./admin-address.vue?vue&type=script&lang=js"
export * from "./admin-address.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports